module.exports = __webpack_public_path__ + "imgs/back2.dac0e55c2337e7c6c3c0eb7e60fac381.svg";